import React, { Component } from 'react';
import { connect } from 'react-redux';
import sentGAEvent from '@/ga';
import Upload from '../upload/Upload';
import ConvertWork from './children/ConvertWork';
import { withTranslation } from 'react-i18next';

import '@/assets/convert.less';
import action from '../../redux/action';
import Utils from '@/utils/index';
class Convert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoAccept:
        '.mkv,.mov,.mp4,.avi,.wmv,.vob,.webm,.asf,.f4v,.flv,.mpg,.mpeg,.ts,.mxf,.ogv,.swf,.gif',
      audioAccept: '.wav,.mp3,.m4a,.aac,.webm,.flac,.mp4,.mov',
      // imageAccept: '.gif,.jpg,.jpeg,.png,.bmp,.tiff,.webp,.ico',
      imageAccept: '.gif,.jpg,.jpeg,.png,.bmp,.webp,.ico',
    };
    // 监听hitpaw-online-root展示改变头部样式，字体从白变黑
    Utils.observerRootDOM(Utils.setHeaderStyle);
  }

  componentDidMount() {
    let action;
    if (this.props.type === 'image') {
      action = '34IC_EnterFuncPage';
    } else if (this.props.type === 'audio') {
      action = '29AC_EnterFuncPage';
    } else {
      action = '36VC_EnterFuncPage';
    }
    if (action) {
      sentGAEvent({
        category: 'EnterFuncPage',
        action: action,
        label: 'Null',
      });
    }
  }

  render() {
    const { t, type } = this.props;
    return (
      <div className='Convert'>
        <h1>
          {type === 'audio'
            ? t('HitPaw Online Audio Converter')
            : type === 'image'
            ? t('HitPaw Online Image Converter')
            : t('HitPaw Online Video Converter')}
        </h1>
        <p>
          {type === 'audio'
            ? t(
                'Convert audios to MP3, AAC, FLAC, WMA and more formats for free.'
              )
            : type === 'image'
            ? t(
                'Convert images to JPG, PNG, BMP, TIFF and more formats for free.'
              )
            : t('Convert videos to any formats as your requirements.')}
        </p>
        {this.props.files.length ? (
          <ConvertWork
            accept={
              this.props.type === 'image'
                ? this.state.imageAccept
                : this.state.videoAccept + ',' + this.state.audioAccept
            }
            type={this.props.type}
          />
        ) : (
          <Upload
            visible={true}
            accept={
              this.props.type === 'image'
                ? this.state.imageAccept
                : this.state.videoAccept + ',' + this.state.audioAccept
            }
            maxLength={2}
            work='convert'
            type={this.props.type}
            addFileByUrlVisible={this.props.type !== 'image'}
          />
        )}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  files: state.files.files,
});
const mapDispatchToProps = (dispatch) => ({
  onFilesChange: (files) => dispatch(action.onFilesChange(files)),
});
export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['convert'])(Convert));
